import { Maybe } from '@pylot-data/fwrdschema'

type PropType = {
    isAccordion?: Maybe<boolean>
}

const MinusIcon = ({ isAccordion = false }: PropType) => {
    const fillColor = isAccordion ? '#857149' : '#080807'
    return (
        <svg
            width="14"
            height="2"
            viewBox="0 0 14 2"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.22222 0H0V1.55556H6.22222H7.77778H14V0H7.77778H6.22222Z"
                fill={fillColor}
            />
        </svg>
    )
}
export default MinusIcon
